<template>
  <div class="newsroom-post">
    <a-breadcrumb>
      <a-breadcrumb-item>Home</a-breadcrumb-item>
      <a-breadcrumb-item>
        <router-link to="/newsroom">Newsroom</router-link>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <article>
      <a-col class="news-title">
        <h3>{{ article.title }}</h3>
      </a-col>
      <a-col class="news-info">
        Date:&nbsp;
        <time class="news-time">
          {{
          getDate(article.year, article.month, article.day)
          }}
        </time>
        <span>Category: {{ article.category }}</span>
      </a-col>
      <p class="markdown-body" v-html="article.text"></p>
    </article>
  </div>
</template>

<script>
// import axios from "axios";

export default {
  name: "NewsroomPost",
  metaInfo() {
    return {
      title: this.postTitle,
      titleTemplate: null
    };
  },
  data() {
    return {
      article: "postContent",
      postTitle: ""
    };
  },
  methods: {
    getPost() {
      let queryLink =
        "https://rest.cnsian.com/api/post?slug=" + this.$route.params.slug;
      // console.log(queryLink);
      // axios.get(queryLink).then(res => (this.article = res.data.data));
      // axios.get(queryLink).then(res => {
      //   this.article = res.data.data
      //   this.postTitle = res.data.data.title
      // });
      fetch(queryLink)
        .then(res => res.json())
        .then(data => {
          this.article = data.data;
          this.postTitle = data.data.title;
        });
      // console.log(this.article);
    },
    getDate(year, mon, day) {
      let formatedCreatedTime = year + "-" + mon + "-" + day;
      return formatedCreatedTime;
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        this.getPost();
      }
    }
  }
};
</script>

<style lang="scss">
@import url("https://cdnjs.cloudflare.com/ajax/libs/github-markdown-css/3.0.1/github-markdown.min.css");

.newsroom-post {
  margin: 2em auto 10em auto;
  max-width: 75%;
  ul > li,
  ol > li {
    display: list-item;
  }
  article {
    .news-title {
      text-align: center;
    }
    .news-info {
      text-align: center;
    }
    .news-time {
      margin-right: 17px;
    }
    img {
      max-width: 100%;
      margin: 1em 0;
    }
  }
  .markdown-body {
    box-sizing: border-box;
    min-width: 200px;
    max-width: 980px;
    margin: 0 auto;
    padding: 45px;
    ul {
      li {
        list-style: disc;
      }
    }
  }

  @media (max-width: 767px) {
    .markdown-body {
      padding: 15px;
    }
  }
}
</style>
